import {
    Component,
    Input,
    OnChanges,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fa-icon',
    templateUrl: './fn-fa-icon.component.html',
    styleUrls: ['./fn-fa-icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FnFaIconComponent implements OnInit, OnChanges {
    @Input() icon: string;

    @Input() style: string;

    @Input() size = '11px';

    @Input() animation: string;

    @Input() color: string;

    @Input() align: string;

    public format: string;

    PREFIX = 'fn-';

    constructor() { }

    ngOnInit() {
        this.formatClass();
    }

    private formatClass() {
        if (this.style === undefined) {
            this.style = 'fas';
        }

        this.format = this.style + ' ';
        this.format += this.PREFIX + this.icon;
        this.format += this.animation
            ? ' anim-' + this.animation + ' animated'
            : '';
        this.format += this.align ? ' pull-' + this.align : '';
    }

    ngOnChanges() {
        this.formatClass();
    }
}
